import { formatListingPriceCompact } from 'common/formatters';

export const GOOGLE_MAPS_MARKER_SHAPE_CIRCLE = 'GOOGLE_MAPS_MARKER_THEME_CIRCLE';
export const GOOGLE_MAPS_MARKER_SHAPE_BOX = 'GOOGLE_MAPS_MARKER_THEME_BOX';

export const GOOGLE_MAPS_MARKER_THEME_LISTING = 'GOOGLE_MAPS_MARKER_THEME_LISTING';
export const GOOGLE_MAPS_MARKER_THEME_LISTING_VIEWED = 'GOOGLE_MAPS_MARKER_THEME_LISTING_VIEWED';
export const GOOGLE_MAPS_MARKER_THEME_LISTING_VIEWING = 'GOOGLE_MAPS_MARKER_THEME_LISTING_VIEWING';
export const GOOGLE_MAPS_MARKER_THEME_TOUR = 'GOOGLE_MAPS_MARKER_THEME_TOUR';
export const GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED = 'GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED';
export const GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED_VIEWING = 'GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED_VIEWING'; // eslint-disable-line max-len
export const GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED_VIEWED = 'GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED_VIEWED';
export const GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR = 'GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR';
export const GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR_VIEWING = 'GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR_VIEWING'; // eslint-disable-line max-len
export const GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR_VIEWED = 'GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR_VIEWED'; // eslint-disable-line max-len
export const GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR = 'GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR';
export const GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR_VIEWING = 'GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR_VIEWING'; // eslint-disable-line max-len
export const GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR_VIEWED = 'GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR_VIEWED'; // eslint-disable-line max-len

const GOOGLE_MAPS_MARKER_THEME_TO_SHAPE_TO_URL_MAPPPING = {
  [GOOGLE_MAPS_MARKER_THEME_LISTING]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/google-maps-circle.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/google-maps-box.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_VIEWED]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/google-maps-circle-gray.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/google-maps-box-gray.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_VIEWING]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/google-maps-circle-black.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/google-maps-box-black.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_TOUR]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/google-maps-circle-yellow.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/google-maps-box-yellow.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/google-maps-heart-small.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/google-maps-box-heart.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED_VIEWING]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/google-maps-heart-small.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/google-maps-box-dark-heart.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED_VIEWED]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/google-maps-heart-small.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/google-maps-box-grey-heart.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/map-pin-circle-blue-white-dot.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/map-pin-bolt-bright-blue.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR_VIEWING]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/map-pin-circle-dark-blue-white-dot.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/map-pin-bolt-dark-blue.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR_VIEWED]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/map-pin-circle-grey-white-dot.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/map-pin-bolt-grey.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/map-pin-circle-blue-white-play.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/map-pin-play-bright-blue.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR_VIEWING]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/map-pin-circle-dark-blue-white-play.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/map-pin-play-dark-blue.svg',
  },
  [GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR_VIEWED]: {
    [GOOGLE_MAPS_MARKER_SHAPE_CIRCLE]: '/images/map-pin-circle-grey-white-play.svg',
    [GOOGLE_MAPS_MARKER_SHAPE_BOX]: '/images/map-pin-play-grey.svg',
  },
};

export const getMarkerShape = (zoomLevel) => {
  return zoomLevel >= 12 ? GOOGLE_MAPS_MARKER_SHAPE_BOX : GOOGLE_MAPS_MARKER_SHAPE_CIRCLE;
};

export const getMarkerLabelConfig = ({ markerShape, listing, currentUser }) => {
  switch (markerShape) {
    case GOOGLE_MAPS_MARKER_SHAPE_BOX:
      return {
        text: formatListingPriceCompact({ listing, currentUser }),
        color: '#FFFFFF',
        fontSize: '12px',
        fontWeight: '600',
        fontFamily: 'Whitney, sans-serif',
      };
    case GOOGLE_MAPS_MARKER_SHAPE_CIRCLE:
      return null;
    default:
      throw new Error(`Not found marker label config for shape ${markerShape}`);
  }
};

export const getMarkerIconLabelOrigin = ({ markerTheme, googleMaps }) => {
  switch (markerTheme) {
    case GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED:
      return new googleMaps.Point(21, 13);
    case GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED_VIEWED:
      return new googleMaps.Point(21, 13);
    case GOOGLE_MAPS_MARKER_THEME_LISTING_SAVED_VIEWING:
      return new googleMaps.Point(21, 14);
    case GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR:
    case GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR_VIEWED:
    case GOOGLE_MAPS_MARKER_THEME_LISTING_SELF_TOUR_VIEWING:
      return new googleMaps.Point(21, 14);
    case GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR:
    case GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR_VIEWING:
    case GOOGLE_MAPS_MARKER_THEME_LISTING_3D_TOUR_VIEWED:
      return new googleMaps.Point(21, 14);
    default:
      return new googleMaps.Point(21, 10);
  }
};

export const getMarkerIconConfig = ({ markerShape, googleMaps, markerTheme }) => {
  switch (markerShape) {
    case GOOGLE_MAPS_MARKER_SHAPE_BOX:
      return {
        url: GOOGLE_MAPS_MARKER_THEME_TO_SHAPE_TO_URL_MAPPPING[markerTheme][markerShape],
        scale: 1,
        labelOrigin: getMarkerIconLabelOrigin({ markerTheme, googleMaps }),
      };
    case GOOGLE_MAPS_MARKER_SHAPE_CIRCLE:
      return {
        url: GOOGLE_MAPS_MARKER_THEME_TO_SHAPE_TO_URL_MAPPPING[markerTheme][markerShape],
        scale: 1,
      };
    default:
      throw new Error(`Not found marker icon config for shape ${markerShape}`);
  }
};

export const centerMarkersOnMap = ({ googleMaps, map, markers }) => {
  const boundsOffset = 0.002;

  if (!markers.size === 0) {
    return;
  }

  const bounds = Array.from(markers.values()).reduce(
    (bound, marker) => bound.extend(marker.getPosition()),
    new googleMaps.LatLngBounds()
  );
  const center = bounds.getCenter();

  bounds
    .extend(new googleMaps.LatLng(center.lat() + boundsOffset, center.lng() + boundsOffset))
    .extend(new googleMaps.LatLng(center.lat() - boundsOffset, center.lng() - boundsOffset));

  map.setCenter(center);
  map.fitBounds(bounds);
};

export const getCenterByArea = ({ googleMaps, area }) => {
  const bounds = Array.from(area).reduce(
    (bound, coord) => bound.extend(new googleMaps.LatLng(coord[1], coord[0])),
    new googleMaps.LatLngBounds()
  );

  return bounds.getCenter();
};

export const getMapArea = ({ map }) => {
  const topRightLat = map
    .getBounds()
    .getNorthEast()
    .lat();
  const topRightLng = map
    .getBounds()
    .getNorthEast()
    .lng();
  const bottomLeftLat = map
    .getBounds()
    .getSouthWest()
    .lat();
  const bottomLeftLng = map
    .getBounds()
    .getSouthWest()
    .lng();

  return [
    [bottomLeftLng, bottomLeftLat],
    [topRightLng, bottomLeftLat],
    [topRightLng, topRightLat],
    [bottomLeftLng, topRightLat],
    [bottomLeftLng, bottomLeftLat],
  ];
};

const fromLatLngToPoint = ({ map, googleMaps, latLng }) => {
  const topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
  const bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
  const scale = 2 ** map.getZoom();
  const worldPoint = map.getProjection().fromLatLngToPoint(latLng);
  return new googleMaps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
};

export const fitMarkerOnMap = ({ marker, googleMaps, isMobile, map }) => {
  const overlayHeight = 480;

  const markerPoints = fromLatLngToPoint({
    map,
    googleMaps,
    latLng: new googleMaps.LatLng(
      marker.getPosition().lat(),
      marker.getPosition().lng()
    ),
  });

  const southWestPoints = fromLatLngToPoint({
    map,
    googleMaps,
    latLng: new googleMaps.LatLng(
      map.getBounds().getSouthWest().lat(),
      map.getBounds().getSouthWest().lng()
    ),
  });

  const mapHeight = southWestPoints.y;
  const markerDistanceFromTopOfMap = markerPoints.y;

  const distanceFromBottom = mapHeight - markerDistanceFromTopOfMap;
  if (isMobile && (distanceFromBottom < overlayHeight)) {
    map.panBy(0, markerDistanceFromTopOfMap - 120);
  }
};

export const getCurrentLocation = (options = {}) => {
  const { enableHighAccuracy, timeout, maximumAge } = options;

  return new Promise((resolve, reject) => {
    global.navigator.geolocation.getCurrentPosition(
      (position) => resolve(position),
      (error) => reject(error),
      { enableHighAccuracy, timeout, maximumAge }
    );
  });
};
